import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import './appointments.scss';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as schedulerActions from '../../scheduler/mySchedule/mySchedule.actions';

export class StaffSelectorComponent extends Component {
  
    handleStaffSelection(staffId) {
				const { setStaffSelection } = this.props;
				setStaffSelection(staffId);
    }

    renderStaffSelector() {
      const { staffList } = this.props;
      return (
        <div>
          {
            staffList ?
            <select onChange={(e) => this.handleStaffSelection(e.target.value)}>
              <option value="none" key="none">Select...</option>
                {
                    staffList.map((s) => (
                        <option value={s.userId.toString()} key={s.userId}>{s.firstName} {s.lastName}</option>
                    ))
                }
            </select>
            : 
            null
          }
        </div>
      )
    }

  render() {
    return (
      <div id='staff-selector'>
          <div className='selector-description'>
						<span className='select-staff-text'>Who?</span>
						<div>
						<span className='required-field-span'>* </span>Required
						</div>
					</div>
          <p className='staff-selector-instructions'>With whom would you like to schedule an appointment?</p>
				<div className='staff-selector-element-container'>
					{this.renderStaffSelector()}
				</div>
      </div>
    );
  }
}

StaffSelectorComponent.propTypes = {
	setStaffSelection: PropTypes.func.isRequired,
};

const mapStateToProps = ({ scheduler, auth }) => {
  return {
      scheduler,
      auth,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      schedulerActions: bindActionCreators(schedulerActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffSelectorComponent);



// WEBPACK FOOTER //
// src/dashboard/appointments/staff-selector.component.js